import _ from 'lodash';
import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { getDonorsFromFolder } from '../../../utils/donorHelpers';
import { parseTextStyling } from '../../../utils/shared';
import { DEFAULT_CYCLE } from './AlbuquerqueConstants';

class AlbuquerqueDonor extends Component {
  constructor(props) {
    super(props);
    this._cycleTimeoutHandler = null;
    this._donors = [];
    this._totalDonors = [];

    this.state = { index: 0 }
  }
  
  componentWillMount() {
    const donors = getDonorsFromFolder(this.props.donors, this.props.content.folder_modules, this.props.module.id);
    this._donors = _.orderBy(donors, [donor => donor.sorting_name.toLowerCase()], ['asc']);
    this._totalDonors = this._donors.length;
  }
  
  componentDidMount() {
    this.cycleDonorIndex();
  }

  componentWillUnmount() {
    clearTimeout(this._cycleTimeoutHandler);
  }

  cycleDonorIndex = () => {
    const time = _.get(this.props.module, "contents.custom_fields.cycle_time.val", DEFAULT_CYCLE);
    if (this._totalDonors - 1 === this.state.index) {
      this.setupCycle();
    } else {
      this._cycleTimeoutHandler = setTimeout(() => {
        this.setState({ index: this.state.index + 1 });
        this.cycleDonorIndex();
      }, time * 1000);
    }
  }

  setupCycle = () => {
    const time = _.get(this.props.module, "contents.custom_fields.cycle_time.val", DEFAULT_CYCLE);
    this._cycleTimeoutHandler = setTimeout(() => {
      this.props.cycle();
    }, time * 1000);
  }

  render() {
    const nameStyleObj = _.get(this.props.module, 'contents.custom_fields.donor_name_style', null);
    const nameStyle = parseTextStyling(nameStyleObj);
    const titleStyleObj = _.get(this.props.module, 'contents.custom_fields.header_style', null);
    const titleStyle = parseTextStyling(titleStyleObj);
    const subheaderStyleObj = _.get(this.props.module, 'contents.custom_fields.subheader_style', null);
    const subheaderStyle = parseTextStyling(subheaderStyleObj);    
    const header = _.get(this.props.module, 'name', null);
    const subheader = _.get(this.props.module, 'contents.custom_fields.subheader.val', null);
    const underline = _.get(this.props.module, 'contents.custom_fields.horizontal_line.val', _.get(this.props.module, 'contents.custom_fields.horizontal_line.default', false));
    const deceased = _.get(this.props.module, 'contents.custom_fields.deceased.val', false);
    const { index } = this.state;
    const donorName = _.get(this._donors[index], 'name', '');

    return (
      <div>
        {/* <div style={{ position: "absolute", width: "100%", height: "100%", opacity: OPACITY_PERCENTAGE, backgroundColor: OPACITY_COLOR }}/> */}
        <CSSTransitionGroup
          transitionName='slowfade'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
            <div key={index}>
              <div style={{ position: "absolute", top: "7.5vh", left: "10vh" }}>
                <div style={{ ...titleStyle, fontFamily: "legacysans-bold" }}>{header}</div>
                {
                  underline ?
                  <div style={{ backgroundColor: 'white', opacity: 1, width: this.props.width * .8875, height: '1px', position: "relative", top: "1.54vh" }} />
                  :
                  <div style={{ ...subheaderStyle, fontFamily: "legacysans-book" }}>{subheader}</div>
                }
              </div>
              <div style={{ position: "absolute", width: "100%", height: "100%", display: "table" }}>
                <div style={{ width: "45%", display: "table-cell", verticalAlign: "middle", paddingLeft: "25%", paddingRight: "25%" }}>
                  <div style={{ ...nameStyle }}>{donorName}</div>
                </div>
              </div>
            </div>
        </CSSTransitionGroup>

        <div style={{ position: "absolute", right: "10vh", bottom: "4.62vh" }}>
          <CSSTransitionGroup
            component='div'
            transitionName='slowfade'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            {
              deceased ?
                <div key={'header-' + this._categoryIndex} style={{ fontFamily: "legacysans-book", color: "white", fontSize: "2.46vh" }}>
                  <span>*Deceased</span>
                </div>
                : null
            }
          </CSSTransitionGroup>
        </div>
      </div>
    );
  }
}

export default AlbuquerqueDonor;


// WEBPACK FOOTER //
// ./src/Components/Theme/Albuquerque/AlbuquerqueDonor.jsx